import { useNavigate } from "react-router";
import { useClientContext } from "./ClientWorkspace";
import { flowLabel, isActive, type ClientPipeline } from "./client-model";
import { transformDescription } from "../../lib/friendly-labels";
import { modeLabel } from "../../lib/mode-labels";
import { Table, type Column } from "../../components/primitives/Table";
import { Badge } from "../../components/primitives/Badge";
import { EmptyState } from "../../components/primitives/EmptyState";
import { ButtonLink } from "../../components/primitives/ButtonLink";

/** Pipelines tab: this client's pipelines in the selected environment, with
 *  the route into the wizard already scoped to that client. */
export function ClientPipelines() {
  const { org, pipelines } = useClientContext();
  const nav = useNavigate();

  const columns: Column<ClientPipeline>[] = [
    {
      key: "name",
      label: "PIPELINE",
      render: (p) => (
        <div>
          <div className="mono">{p.name}</div>
          <div className="run-sub">{transformDescription(p.transformId)}</div>
        </div>
      ),
    },
    { key: "flow", label: "FLOW", render: (p) => flowLabel(p) },
    { key: "mode", label: "MODE", render: (p) => <Badge tone="muted">{modeLabel(p.triggers?.[0]?.mode)}</Badge> },
    { key: "env", label: "ENVIRONMENT", render: (p) => <span className="mono">{p.environment ?? "—"}</span> },
    {
      key: "status",
      label: "STATUS",
      render: (p) => <Badge tone={isActive(p) ? "ok" : "muted"}>{isActive(p) ? "Active" : "Paused"}</Badge>,
    },
  ];

  return (
    <Table
      columns={columns}
      rows={pipelines}
      rowKey={(p) => p.id}
      onRowClick={(p) => nav(`/pipelines/${p.id}`)}
      empty={
        <EmptyState
          title="No pipelines for this client yet."
          action={
            <ButtonLink to={`/pipelines/new?organizationId=${encodeURIComponent(org.id)}`}>
              New pipeline
            </ButtonLink>
          }
        />
      }
    />
  );
}
